module.exports = __webpack_public_path__ + "img/d201204-3.bc588b0a.jpg";